import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export default function ProductReservationView(props) {
  const { t, i18n } = useTranslation("modals");
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (props.onHideEvent) {
      props.onHideEvent();
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
          <div className="flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="overflow-hidden relative text-left bg-white rounded-lg shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-lg">
                <form>
                  <div className="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="flex items-start">
                      <div className="flex flex-shrink-0 justify-center items-center mx-auto w-12 h-12 bg-indigo-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="text-indigo-600"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                          <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900"
                        >
                          {props.modalview.header}
                        </Dialog.Title>
                      </div>
                    </div>

                    <div className="mt-4">
                      {!props.data && (
                        <div className="p-4 text-center">
                          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
                          <p className="mt-4 text-sm text-gray-500">
                            Bezig met laden...
                          </p>
                        </div>
                      )}

                      {props.data && !props.data.id && (
                        <div className="p-4 bg-yellow-50 rounded-md">
                          <div className="flex">
                            <div className="flex-shrink-0">
                              <svg
                                className="w-5 h-5 text-yellow-400"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <div className="ml-3">
                              <p className="text-sm text-yellow-700">
                                Geen reserveringen meer.
                                <br />
                                De reserveringen die je hebt gehad op dit
                                product zijn allemaal afgewezen.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {props.data && props.data.id && (
                        <div className="mt-4">
                          {props.data && props.data.status == 1 && (
                            <p className="mb-4 text-sm text-gray-500">
                              {props.modalview.message}
                            </p>
                          )}

                          {props.data && props.data.status == 9 && (
                            <div className="p-4 mb-4 bg-green-50 rounded-md">
                              <div className="flex">
                                <div className="flex-shrink-0">
                                  <svg
                                    className="w-5 h-5 text-green-400"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                                <div className="ml-3">
                                  <p className="text-sm font-medium text-green-800">
                                    STATUS :{" "}
                                    <span className="font-bold">VERKOCHT</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="grid grid-cols-2 gap-6">
                            <div className="space-y-2">
                              <div className="text-sm font-medium text-gray-500">
                                Contact Persoon
                              </div>
                              <div className="text-base font-medium text-gray-900">
                                {props.data.user.full_name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {props.data.user.phone1}
                              </div>
                              <div className="text-sm text-gray-500">
                                {props.data.user.email}
                              </div>
                            </div>

                            {props.data.company && (
                              <div className="space-y-2">
                                <div className="text-sm font-medium text-gray-500">
                                  Bedrijf
                                </div>
                                <div className="text-base font-medium text-gray-900">
                                  {props.data.company.name}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {props.data.company.phone1}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {props.data.company.email1}
                                </div>
                              </div>
                            )}

                            {!props.data.company && (
                              <div className="space-y-2">
                                <div className="text-sm font-medium text-gray-500">
                                  Type
                                </div>
                                <div className="text-base font-medium text-gray-900">
                                  Particulier
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className={`inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm sm:ml-3 sm:w-auto sm:text-sm ${
                        !props.data || !props.data.id || props.data.status != 1
                          ? "bg-indigo-300 cursor-not-allowed"
                          : "bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      }`}
                      onClick={() => props.setNewStateEvent(1)}
                      disabled={
                        !props.data || !props.data.id || props.data.status != 1
                      }
                    >
                      Verkoop definitief maken
                    </button>
                    <button
                      type="button"
                      className={`mt-3 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm ${
                        !props.data || !props.data.id || props.data.status != 1
                          ? "bg-red-300 cursor-not-allowed"
                          : "bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                      }`}
                      onClick={() => props.setNewStateEvent(2)}
                      disabled={
                        !props.data || !props.data.id || props.data.status != 1
                      }
                    >
                      Verkoop afwijzen
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 mt-3 w-full text-base font-medium text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={handleClose}
                    >
                      Sluiten
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
